import * as Types from '@/store/types'
import { API_PATH } from '@/global/config'
import http from '@/plugins/http'

export default {
  state() {
    return {
      userInfo: null
    }
  },
  mutations: {
    [Types.SET_USER](state, userInfo) {
      state.userInfo = userInfo
    }
  },
  actions: {
    async [Types.GET_USER]({ commit }) {
      const res = await http.get(API_PATH.user.info)
      const { data } = res
      commit(Types['SET_USER'], data)
      return data
    }
  },
  namespaced: true
}
